import React, { useState } from 'react';
import './UserMenu.css';

function UserMenu({ user, onLogout, onShowSettings }) {
  const [showDropdown, setShowDropdown] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('spiritToken');
    localStorage.removeItem('spiritUser');
    onLogout();
  };

  return (
    <div className="user-menu">
      <button 
        className="user-menu-trigger"
        onClick={() => setShowDropdown(!showDropdown)}
        aria-label="Menu utilisateur"
      >
        <span className="user-icon">👤</span>
        <span className="user-name">{user.username}</span>
        <span className="dropdown-arrow">{showDropdown ? '▲' : '▼'}</span>
      </button>

      {showDropdown && (
        <div className="user-dropdown">
          <div className="user-info">
            <div className="user-detail">
              <strong>👤 {user.username}</strong>
            </div>
            <div className="user-detail">
              ✨ {user.avatarName}
            </div>
          </div>
          
          <hr className="dropdown-divider" />
          
          <button 
            className="dropdown-item"
            onClick={() => {
              setShowDropdown(false);
              onShowSettings();
            }}
          >
            ⚙️ Paramètres
          </button>
          
          <button 
            className="dropdown-item logout"
            onClick={handleLogout}
          >
            🚪 Se déconnecter
          </button>
        </div>
      )}
      
      {showDropdown && (
        <div 
          className="dropdown-overlay" 
          onClick={() => setShowDropdown(false)}
        />
      )}
    </div>
  );
}

export default UserMenu;